import React from "react";
import Categories from "../components/Categories";
import ProductFeed from "../components/ProductFeed";
import Carousel from "../components/AppCarousel";
import { motion } from "framer-motion";
import { pageTransition, pageSlide } from "../utils/styleUtils";

function HomeScreen() {
    return (
        <motion.div
      initial="initial"
      animate="in"
      exit="out"
      variants={pageSlide}
      transition={pageTransition}
    >
      <Carousel />
      <Categories />
      <ProductFeed />
    </motion.div>
    )
}

export default HomeScreen
